/* Import images of techstacks you're skilled at here. */
import html from "../assets/html.png";
import node from "../assets/node.png";
import react from "../assets/react.png";
import javascript from "../assets/javascript.png";
import nextJs from "../assets/nextJs.png";
import flutter from "../assets/flutter.png";
import tailwind from "../assets/tailwind.png";

/* URLs */
export const LINKEDIN_URL = "https://www.linkedin.com/in/chakit-bhandari";
export const GITHUB_URL = "https://github.com/Chakit22";
export const LEETCODE_URL = "https://leetcode.com/Chakit_Bhandari";
export const RESUME_URL =
  "https://drive.google.com/file/d/1VljViD24HTqhRf3oYn3IPKndcZsvI5PE/view?usp=sharing";

/* Email */
export const EMAIL_ID = "chakitbhandari22@gmail.com";

/* Github profile username whoch contains the respective projects. */
export const GITHUB_USERNAME = "ChakitBhandari";

/* Home Page */

// Your Name
export const homePageName = "Chakit Bhandari";

// Title
export const homePageTitle = "I'm an AI Full Stack Developer";

// Profile description
export const homePageDescription =
  "I'm an AI Full Stack Developer passionate about building intelligent, scalable solutions. From voice AI agents to serverless architectures, I create software that makes a real impact.";

/* About Page */

export const aboutPageName = "Chakit";

export const aboutPageDescription = `I am an AI Full Stack Developer dedicated to creating impactful and high-performance applications. With a strong foundation in problem solving (1000+ problems solved, Knight on LeetCode with max rating 1944), I've worked on AI-powered voice agents, crypto pricing engines, and full-stack systems using technologies like Next.js, React, AWS, and LLMs. I'm committed to building intelligent software that makes a positive difference in the world.`;

/* Education */
export const education = {
  degree: "Master's of Information Technology",
  institution: "RMIT University, Melbourne",
  period: "2024 - 2025",
};

/* Achievements */
export const achievements = [
  "Secured 1st place in AI Agents Beginner Hackathon and presented at Microsoft Office, Melbourne",
  "Bagged 3rd rank out of 200 participants in O(NlogN) University event",
  "Solved 1000+ problems on various coding platforms",
  "Knight on LeetCode (Max Rating: 1944), 3 star on CodeChef",
];

/* Skills */

// Mention the Technologies you are proficient in.
export const technologies = [
  { name: "HTML", image: html },
  { name: "TailwindCSS", image: tailwind },
  { name: "Javascript", image: javascript },
  { name: "React", image: react },
  { name: "Next.js", image: nextJs },
  { name: "NodeJS", image: node },
  { name: "Flutter", image: flutter },
];
